import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { NoObjectChosen } from "../../common/NoObjectChosen";
import { selectFolderItems } from "../../common/Sidebar/redux/selectors";
import { toggleAccordion } from "../../common/Sidebar/redux/slice";
import type { StylistValue } from "../../services/api/instances/stylistApi/stylistTypes";
import { createStorageObjectApi } from "../../services/lib/storageObjectManager";
import { getServicePagePath } from "../../services/navigation/navigateToRoute";
import { useAppDispatch } from "../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../services/redux/hooks/use-selector";
import { ResizableWrapper } from "../../shared/components/ResizableWrapper";
import { StylistMain } from "./Components/StylistMain";
import { StylistResult } from "./Components/StylistResult";
import { useStylist } from "./hook/use-stylist";
import {
  createStylistAction,
  updateStylistWithChildrenAction,
} from "./redux/actions";
import { selectSelectedStylist, selectStylists } from "./redux/selectors";
import { setSelectedStylistAction, setStylistAction } from "./redux/slice";
import styles from "./styles.module.css";
import { StorageObject } from "../../services/api/instances/storageApi/types/object_types";

export const Stylist = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { isResultLoading, handleSelectAssistant, handleClickStylist } =
    useStylist();
  const stylists = useAppSelector(selectStylists);
  const folderItems = useAppSelector(selectFolderItems);
  const selectedStylist = useAppSelector(selectSelectedStylist);
  const navigator = useNavigate();

  const storage = createStorageObjectApi<StylistValue>(stylists);

  const addStylist = () => {
    dispatch(createStylistAction({ isFolder: "object" }))
      .unwrap()
      .then((response: StorageObject<StylistValue>) => {
        dispatch(
          updateStylistWithChildrenAction({
            childId: response.id,
            parentId: selectedStylist?.id as string,
          }),
        );
        const newStylist = storage.addItem(response, selectedStylist?.id);
        dispatch(setStylistAction(newStylist));
        dispatch(setSelectedStylistAction(response));
        navigator(getServicePagePath(response.id, "stylizator"));
        if (!folderItems.includes(selectedStylist?.id as string)) {
          dispatch(toggleAccordion(selectedStylist?.id as string));
        }
      });
  };

  return (
    <>
      {selectedStylist?.value === null ? (
        <NoObjectChosen
          message={t("stylist.no_object_message")}
          folderName={selectedStylist?.friendly_name}
          onClick={addStylist}
        />
      ) : (
        <ResizableWrapper
          leftBlock={
            <StylistMain
              onClick={handleClickStylist}
              handleSelectAssistant={handleSelectAssistant}
              className={styles.wrapper}
            />
          }
          rightBlock={
            <StylistResult
              isResultsDisabled={isResultLoading}
              className={styles.wrapper}
            />
          }
          isCollapsible={false}
          leftBlockSize={50}
          leftBlockMinSize={35}
          rightBlockSize={50}
          rightBlockMinSize={35}
          rightClassName={styles["right-block"]}
        />
      )}
    </>
  );
};
